import axios from '~/clients/axios';
import { NEW_CAR_DELIVERY } from '~/constants/endpoints';
import type { DeliveryData } from '~/contracts/common/Geolocation';

export default function fetchNewCarDelivery(
  zip5: string
): Promise<DeliveryData> {
  const url = new URL(NEW_CAR_DELIVERY);
  url.searchParams.set('Zip5', zip5);
  url.searchParams.set('OfferingType', 'new');

  return axios.get<DeliveryData>(url.toString()).then(res => res.data);
}
